'use strict';

angular.module('programme')

.component('playerInfo', {
    templateUrl: 'modules/programme/editor-components/player-list/player-info.html',
    bindings: {
        model: '<',
    },
    controller: 'PlayerInfoCtrl',
    controllerAs: '$ctrl',
})

.controller('PlayerInfoCtrl', function ($element)
{
    this.$onInit = function ()
    {
        $element.addClass('player-info clearfix box');

        if (!this.model.image || !this.model.image.length) {
            this.model.image = [
                {
                    type: 'image',
                }
            ];
        }
    };

    this.open = function ()
    {
        $element.addClass('open');
    };

    this.close = function ()
    {
        $element.removeClass('open');
    };
});
